export default (props) => (
  <svg {...props} viewBox="0 0 40 40" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h40v40H0z" />
      <path
        d="M33.02 28.88h-1.05V18.534c0-5.925-4.284-10.86-9.902-11.848A2.145 2.145 0 0 0 19.998 4a2.143 2.143 0 0 0-2.067 2.687c-5.617.987-9.901 5.923-9.901 11.848V28.88H6.98a.982.982 0 0 0-.98.987c0 .546.438.987.98.987h7.814C14.844 33.699 17.157 36 20 36c2.844 0 5.158-2.3 5.207-5.147h7.813c.542 0 .981-.441.981-.987a.983.983 0 0 0-.98-.987"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
